import I18n from "^/config/i18n";

function localizeAttribute(attribute, objClass) {
  const keys = [
    ["attributes", objClass, attribute].join("."),
    ["attributes", "common", attribute].join("."),
  ];
  const r = keys
    .map((key) => I18n.exists(key, { ns: "editing", returnObjects: true }))
    .filter((fn) => fn).length;
  if (r === 0) {
    return { title: `Missing key for  ${keys.join(" or ")}` };
  }
  return I18n.t(keys, { ns: "editing", returnObjects: true });
}

function localizeAttrList(attrList, objClass) {
  const attributes = {};
  attrList.forEach((key) => {
    attributes[key] = localizeAttribute(key, objClass);
  });
  return attributes;
}

export { localizeAttribute, localizeAttrList };
